import React, { useState, useCallback } from 'react';
import DefectTrendOverMonths from 'components/graphs/DefectTrendOverMonths';
import SystemDefectFrequency from 'components/graphs/SystemDefectFrequency';
import DefectsPerProductVersion from 'components/graphs/DefectsPerProductVersion';
import useVehicleModels from 'hooks/useVehicleModels';
import FilterForm from 'components/FilterForm';
import './DefectAnalytics.css';

const DefectAnalytics = () => {
    // Function to get the default date range (last 3 months)
    const getDefaultDateRange = () => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 3);

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = ('0' + (date.getMonth() + 1)).slice(-2); // Months are zero-indexed
            const day = ('0' + date.getDate()).slice(-2);
            return `${year}-${month}-${day}`;
        };

        return {
            startDate: formatDate(startDate),
            endDate: formatDate(endDate),
        };
    };

    // Initialize filter state with default date range
    const [filter, setFilter] = useState({
        ...getDefaultDateRange(),
        vehicleModel: '',
    });

    const vehicleModels = useVehicleModels();

    const handleFilterChange = useCallback(
        (e) =>
            setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value })),
        []
    );

    return (
        <main className="defect-analytics-container">
            <FilterForm
                filter={filter}
                handleFilterChange={handleFilterChange}
                vehicleModels={vehicleModels}
            />
            <section className="charts-grid">
                <DefectTrendOverMonths filter={filter} />
                <SystemDefectFrequency filter={filter} />
                <DefectsPerProductVersion filter={filter} />
            </section>
        </main>
    );
};

export default DefectAnalytics;
